import { useNavigate, Link } from 'react-router-dom';
import { useCreateProviderMutation } from '../../Redux/Service/ProviderApi';
import { toast } from 'react-toastify';
import StyledDashboardLayout from '../style';
import ServiceProviderForm from './ServiceProviderForm';
import { handleApiError } from '../../utils/apiErrorHandler';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function ServiceProviderAdd() {
   const navigate = useNavigate();
   const [createProvider] = useCreateProviderMutation();

   const handleSubmit = async (values, { setSubmitting, setFieldValue }) => {
      try {
         setSubmitting(true);
         const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
         const maxFileSize = 2 * 1024 * 1024; // 2MB

         if (values.logo && !validImageTypes.includes(values?.logo?.type)) {
            toast.error('Only JPEG, JPG, and PNG files are allowed for signature');
            setFieldValue('logo', null);
            return;
         }

         if (values?.logo && !(values?.logo?.size <= maxFileSize)) {
            toast.error('File size should be less than 2MB');
            setFieldValue('logo', null);
            return;
         }
         const formData = new FormData();

         // Reconstruct phone number in the format expected by API: (+91) 1234567890
         const phoneNo = `(${values.countryCode}) ${values.phoneNumber}`;

         Object.entries(values).forEach(([k, v]) => {
            if (v !== null && v !== undefined && k !== 'countryCode' && k !== 'phoneNumber') {
               formData.append(k, v);
            }
         });

         // Add the reconstructed phone number
         formData.append('phoneNo', phoneNo);

         const res = await createProvider(formData).unwrap();
         toast.success(res.message);
         navigate('/service-providers');
      } catch (error) {
         handleApiError(error);
      } finally {
         setSubmitting(false);
      }
   };
   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header d-flex justify-content-between m-3">
               <h1>Add Service Provider</h1>
               <Link to="/service-providers" className="btn addBtn">
                  <ArrowBackIcon /> Back
               </Link>
            </div>
            <div className="card customCard p-3 m-3">
               <ServiceProviderForm
                  initialValues={{
                     name: '',
                     email: '',
                     countryCode: '+91',
                     phoneNumber: '',
                     address: '',
                     status: true,
                     logo: null,
                  }}
                  onSubmit={handleSubmit}
                  submitLabel="Create"
               />
            </div>
         </div>
      </StyledDashboardLayout>
   );
}

export default ServiceProviderAdd;
